import React from 'react'
import { View } from 'react-native'
import { MapControlsBar } from '../../../components/map/MapControlsBar'
import { GameChatInputBar } from '../../../components/game/GameChatPanel'
import { gameLogControlParts, type GameLogView } from '../../../components/game/GameLogControls'

/** Real adjoining map/chat bars with a stable unread count for clipping checks. */
export default function ChatUnreadCheckpoint() {
  const [view, setView] = React.useState<GameLogView>('all')
  const parts = gameLogControlParts({ view, onViewChange: setView, canChatOnly: true,
    unreadCount: 12, filtersOpen: false, onFiltersOpenChange: () => undefined,
    filtersActive: false, grown: false, onGrownChange: () => undefined })
  return <View className="flex-1 bg-canvas" style={{ justifyContent: 'center' }}>
    <MapControlsBar onReset={() => undefined} onZoomIn={() => undefined} onZoomOut={() => undefined}
      canZoomIn canZoomOut compact mode="game" onModeChange={() => undefined} />
    <GameChatInputBar gameId="visual-game" onFocusChange={() => undefined} expandOnFocus
      leading={parts.viewToggle} trailing={<View className="flex-row" style={{ gap: 8 }}>{parts.filtersToggle}{parts.growToggle}</View>} />
  </View>
}
